import { useFavoriteTerritoryCellModel } from './favorite-territory-cell.model'
import type { IFavoriteTerritoryCell } from './favorite-territory-cell.types'
import { FavoriteTerritoryCellView } from './favorite-territory-cell.view'

export const FavoriteTerritoryCell = (props: IFavoriteTerritoryCell) => {
  const favoriteTerritoryCellModel = useFavoriteTerritoryCellModel(props)
  return <FavoriteTerritoryCellView {...favoriteTerritoryCellModel} />
}
